/** Video original de la landing page, reubicado dentro del bloque Hero. */
export const heroVideoSrc =
  'https://cdn.magicpatterns.com/uploads/dLNWaB1j1xuVSZXSTcMiyQ/pikaso-untitled-project-2025-11-06%20(1)%20(1)%20(1).mp4'

/** Video de testimonio real compartido por un cliente. */
export const testimonialVideoSrc =
  'https://cdn.magicpatterns.com/uploads/nrL5WYy9Z8FqhiZnue382Y/video_testimonio.mp4'

/** Imagen ambiental de fondo del Hero (no sustituye al video). */
export const heroBackgroundSrc =
  'https://cdn.magicpatterns.com/patterns/generated-images/65e74caa-7e0c-4af7-ad29-23043bf93330.jpg'
